import React from 'react';
import { Search, X, Filter } from 'lucide-react';

const STATUS_OPTIONS = [
  { value: '', label: 'All Statuses' },
  { value: 'confirmed', label: 'Confirmed' },
  { value: 'processing', label: 'Packing' },
  { value: 'shipped', label: 'Shipped' },
  { value: 'delivered', label: 'Complete' },
];

const OrderFilters = ({ searchQuery, setSearchQuery, statusFilter, setStatusFilter, filteredCount, totalCount }) => {
  const hasFilters = searchQuery || statusFilter;

  return (
    <div className="flex flex-col sm:flex-row items-start sm:items-center gap-3 mb-4" data-testid="order-filters">
      <div className="relative flex-1 w-full sm:max-w-sm">
        <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-muted-foreground" />
        <input
          type="text"
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          placeholder="Search order ID, name, or email..."
          className="w-full pl-10 pr-9 py-2.5 rounded-lg border border-border bg-background focus:outline-none focus:ring-2 focus:ring-primary text-sm"
          data-testid="order-search-input"
        />
        {searchQuery && (
          <button onClick={() => setSearchQuery('')} className="absolute right-3 top-1/2 -translate-y-1/2 text-muted-foreground hover:text-foreground" data-testid="clear-search">
            <X className="w-4 h-4" />
          </button>
        )}
      </div>
      <div className="flex items-center gap-2">
        <Filter className="w-4 h-4 text-muted-foreground" />
        <select
          value={statusFilter}
          onChange={(e) => setStatusFilter(e.target.value)}
          className="px-3 py-2.5 rounded-lg border border-border bg-background focus:outline-none focus:ring-2 focus:ring-primary text-sm"
          data-testid="order-status-filter"
        >
          {STATUS_OPTIONS.map(opt => (
            <option key={opt.value} value={opt.value}>{opt.label}</option>
          ))}
        </select>
      </div>
      {hasFilters && (
        <div className="flex items-center gap-2">
          <span className="text-xs text-foreground/50" data-testid="filter-count">
            Showing {filteredCount} of {totalCount}
          </span>
          <button
            onClick={() => { setSearchQuery(''); setStatusFilter(''); }}
            className="text-xs text-primary hover:underline font-medium"
            data-testid="clear-all-filters"
          >
            Clear filters
          </button>
        </div>
      )}
    </div>
  );
};

export default OrderFilters;
